import React from 'react';

export default function GridContainer({ colsMax, colsMin, children }) {
  return (
    <dl className={`my-2 grid gap-2 text-left grid-cols-${colsMin || colsMax} md:grid-cols-${colsMax}`}>
      {children}
    </dl>
  );
}
